import React, { useState } from "react";
import { EaseDrawer } from "../../libs/EaseDrawer";
import { Text1, Text3, Text4, Text5 } from "../../styles";
import { Descriptions, Button, Table, Badge, Spin } from "antd";
import { CopyThat } from "../Common";
import { handleApiExceptions, printRupee } from "../../app_methods";
import { VirtualAccount } from "../../models";
import moment from 'moment';
import { VirtualAccountProfileDrawer } from "./virtual_account_profile_drawer";
import { PermissionHoc } from '../HOC';
import { isEmpty } from "lodash";

const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })


const VirtualAccountDetailsDrawer = (props) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [virtualAccountInstance, setVirtualAccountInstance] = useState({});
    const [isRequesting, setIsRequesting] = useState(false);
    const [profileDrawerVisible, setProfileDrawerVisible] = useState(false);
    const merchant_name = virtualAccountInstance.kyc_flow ? (virtualAccountInstance.profile || {}).business_name : props.current_user.name;
    const [isfetchinKYCData, setIsfetchinKYCData] = useState(false);

    const retrieveDetails = async () => {
        setIsRequesting(true);
        const response = await new VirtualAccount(props.virtualAccount).retrieve({ is_submerchant: props.virtualAccount.is_submerchant });
        if (!response.success) {
            setIsRequesting(false);
            handleApiExceptions(response);
            return;
        }
        setVirtualAccountInstance(new VirtualAccount(response.data.custom_virtual_account));
        setIsRequesting(false);
    };

    const downloadScanner = async () => {
        setIsDownloading(true);
        const response = await props.virtualAccount.get_scanner_link({ is_submerchant: props.virtualAccount.is_submerchant });
        if (!response.success) {
            setIsDownloading(false);
            handleApiExceptions(response);
            return;
        }
        setIsDownloading(false);
        window.open(response.data.url, '_blank');
    };

    const getKYCData = async () => {
        setIsfetchinKYCData(true);
        const response = await virtualAccountInstance.get_kyc_data();
        if (!response.success) {
            setIsfetchinKYCData(false);
            handleApiExceptions(response);
            return;
        }
        retrieveDetails()
        setIsfetchinKYCData(false);
    };

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Virtual Account Details</Text1>
                <Text5 copyable>{virtualAccountInstance.id}</Text5>
            </div>
        )
    };

    const renderDetails = () => {
        return (
            <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                <Descriptions.Item label="Account Name">{merchant_name || '---'}</Descriptions.Item>
                <Descriptions.Item label="A/c Number / IFSC ">
                    <div className="mb-1"> {virtualAccountInstance.virtual_account_number || "---"} </div>
                    <div> {virtualAccountInstance.virtual_ifsc_number || "---"} </div>
                </Descriptions.Item>
                {virtualAccountInstance.virtual_upi_handle ? <Descriptions.Item label="UPI Handle">{virtualAccountInstance.virtual_upi_handle || "---"}</Descriptions.Item> : null}
                {virtualAccountInstance.upi_qrcode_url ? <Descriptions.Item label="UPI QR"><img style={{ maxWidth: 150 }} src={virtualAccountInstance.upi_qrcode_url} />
                    <Button type="link" onClick={downloadScanner} loading={isDownloading} className="pl-2">Download QR</Button>
                </Descriptions.Item> : null}
                {virtualAccountInstance.is_active && !props.virtualAccount.is_submerchant ? <Descriptions.Item label="Collect Request"><PermissableButton required_permission="IC_COLLECT_REQUEST" className="pl-0" type="link" onClick={() => props.toggleCollectRequestModal(virtualAccountInstance)}>Send Collect Request</PermissableButton></Descriptions.Item> : null}
                {virtualAccountInstance.merchant_request_number ? <Descriptions.Item label="Unique Request Number">{virtualAccountInstance.merchant_request_number || "---"}</Descriptions.Item> : null}
            </Descriptions>
        )
    };

    const renderExtraDetails = () => {
        return (
            <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                <Descriptions.Item label="Label">{virtualAccountInstance.label || "---"}</Descriptions.Item>
                <Descriptions.Item label="Auto Deactivate At">{virtualAccountInstance.auto_deactivate_at ? moment(virtualAccountInstance.auto_deactivate_at).format("ll") : '---'}</Descriptions.Item>
                <Descriptions.Item label="Description">{virtualAccountInstance.description || '---'}</Descriptions.Item>
                {
                    virtualAccountInstance.kyc_flow ? (
                        <>
                            <Descriptions.Item label="KYC Status">
                                <Badge color={virtualAccountInstance.profile.status == 'approved' ? 'green' : virtualAccountInstance.profile.status == 'rejected' ? 'red' : 'orange'} text={<Text4 style={{ textTransform: 'capitalize' }}>{virtualAccountInstance.profile.status}</Text4>} />
                                {virtualAccountInstance?.profile?.status === "pending" ? <Button className='ml-2' loading={isfetchinKYCData} onClick={getKYCData} size="small"> Update</Button> : null}
                            </Descriptions.Item>
                            {virtualAccountInstance.profile.status == "rejected" ? <Descriptions.Item label="Rejection Reason">
                                <div> {virtualAccountInstance.profile.rejection_reason || "---"} </div>
                            </Descriptions.Item> : null}
                            <Descriptions.Item label="KYC Profile"><Button type="link" onClick={() => setProfileDrawerVisible(!profileDrawerVisible)} className="pl-0">Show KYC Profile</Button></Descriptions.Item>
                        </>
                    ) : null
                }
                {
                    virtualAccountInstance.phone_numbers && virtualAccountInstance.phone_numbers.length ? (
                        <Descriptions.Item label="Phone Numbers">{virtualAccountInstance.phone_numbers.map((n, i) => i == 0 ? n : <>, {n}</>)}</Descriptions.Item>
                    ) : null
                }
                {
                    !isEmpty(virtualAccountInstance?.transaction_amount_limit || {}) &&
                    <Descriptions.Item className="flex-div" label="Transaction Limit">
                        <div className="flex-col">
                            {
                                Object.keys(virtualAccountInstance?.transaction_amount_limit).map(key => {
                                    const normalizedKey = key.toLowerCase();
                                    let labelText;

                                    if (normalizedKey === "upi_fixed") {
                                        labelText = "Fixed UPI";
                                    } else if (normalizedKey === "upi") {
                                        labelText = "Min UPI";
                                    } else {
                                        labelText = `Max ${normalizedKey.toUpperCase()}`;
                                    }

                                    return (
                                        <div className="mb-10" key={key}>
                                            <b>{labelText}: </b>
                                            {printRupee(virtualAccountInstance?.transaction_amount_limit[key])}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </Descriptions.Item>
                }

                <Descriptions.Item label="UDF 1">{virtualAccountInstance.udf1 || "---"}</Descriptions.Item>
                <Descriptions.Item label="UDF 2">{virtualAccountInstance.udf2 || "---"}</Descriptions.Item>
                <Descriptions.Item label="UDF 3">{virtualAccountInstance.udf3 || "---"}</Descriptions.Item>
                <Descriptions.Item label="UDF 4">{virtualAccountInstance.udf4 || "---"}</Descriptions.Item>
                <Descriptions.Item label="UDF 5">{virtualAccountInstance.udf5 || "---"}</Descriptions.Item>
            </Descriptions>
        )
    };

    const renderRemitterDetails = () => {
        const columns = [
            {
                title: 'Account Number',
                key: 'account_number',
                render: (record) => <div>{record.account_number}</div>
            },
            {
                title: 'IFSC',
                key: 'account_ifsc',
                render: (record) => <div>{record.account_ifsc || "---"}</div>
            },
        ];
        return (
            <Table
                className="mb-4 border-top border-left border-right rounded"
                columns={columns}
                dataSource={virtualAccountInstance.authorized_remitters}
                bordered={false}
                size="middle"
                pagination={false}
            />)
    };


    return (
        <EaseDrawer
            className="merchant-details-wrapper"
            title={false}
            width={470}
            visible={props.visible}
            onOpen={() => retrieveDetails(props.virtualAccount)}
            onClose={props.toggleDetailsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            {

                isRequesting ?
                    <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                        <Spin className="mt-4" tip="Loading..." spinning={isRequesting} />
                    </div>
                    :
                    <div className="mt-3">
                        {renderTitle()}
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: '8px' }}>
                                <Text3 className="d-block" style={{ color: 'black' }} strong>Account Details</Text3>
                                <CopyThat
                                    copyText={`${merchant_name} ${virtualAccountInstance.virtual_account_number} ${virtualAccountInstance.virtual_ifsc_number} ${virtualAccountInstance.virtual_upi_handle || ''}`}
                                    className="ml-2"
                                />
                            </div>
                            <Badge color={virtualAccountInstance.is_active ? 'green' : 'red'} text={<Text3>{virtualAccountInstance.is_active ? 'Active' : 'Inactive'}</Text3>} />
                        </div>
                        {renderDetails()}
                        <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Extra Details</Text3>
                        {renderExtraDetails()}
                        {virtualAccountInstance.authorized_remitters ? virtualAccountInstance.authorized_remitters.length > 0 ?
                            <>
                                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Authorized Source Accounts</Text3>
                                {renderRemitterDetails()}
                            </> : null : null}
                    </div>
            }
            <VirtualAccountProfileDrawer
                virtualAccountInstance={virtualAccountInstance}
                toggleProfileDrawer={() => setProfileDrawerVisible(!profileDrawerVisible)}
                visible={profileDrawerVisible}
            />
        </EaseDrawer>
    )
};

export { VirtualAccountDetailsDrawer };